module.exports = __webpack_public_path__ + "img/implementation.b0db5cf4.jpg";